import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { ApiServiceHolder } from '@core/utils/api-service-holder';
import { Observable } from 'rxjs';
import { IUserPwdResetDto, UserResetPasswordWithCode } from 'src/app/login/interfaces/login.interfaces';
import { IUser, IUserProfile } from '../interfaces/user.interface';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private _api: ApiService) { }

  getByUsername(username: string): Observable<IUser> {
    return this._api.request(ApiServiceHolder.user.getByUsername(username));
  }

  getAll(): Observable<IUser[]> {
    return this._api.request(ApiServiceHolder.user.getAll());
  }

  getAllUserProfiles(): Observable<IUserProfile[]> {
    return this._api.request(ApiServiceHolder.user.getAllUserProfiles());
  }

  update(item: IUser): Observable<IUser> {
    return this._api.request(ApiServiceHolder.user.update(item));
  }

  resetPassword(item: IUserPwdResetDto): Observable<IUserPwdResetDto> {
    return this._api.request(ApiServiceHolder.user.resetPassword(item));
  }

  resetPasswordWithCode(item: UserResetPasswordWithCode): Observable<void> {
    return this._api.request(ApiServiceHolder.user.resetPasswordWithCode(item));
  }

}
